import dayjs from "dayjs";
import axios from "../../axios";
export default {
  namespaced: true,
  state: {
    logs: null,
    logDetail: [],
    trips: [],
    trackings: [],
    tracking: null,
  },
  mutations: {
    SET_LOGS(state, products) {
      state.logs = products;
    },
    SET_LOGS_DETAIL(state, log) {
      console.log(log);
      state.logDetail = log;
    },
    SET_TRIPS(state, live) {
      state.trips = live;
    },
    SET_TRACKINGS(state, data) {
      state.trackings = data;
    },
    SET_TRACKING(state, data) {
      state.tracking = data;
    },
  },
  actions: {
    fetchDataListLogs({ commit }, params) {
      console.log(params);
      return new Promise((resolve, reject) => {
        axios
          .get("log/", {
            params,
          })
          .then((response) => {
            commit("SET_LOGS", response.data);
            resolve(response);
          })
          .catch((error) => {
            // console.log(error), reject(error);
          });
      });
    },
    fetchDataLogDetail({ commit }, { id, date }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`log/detail/${id}/?date=${date}`)
          .then((response) => {
            commit("SET_LOGS_DETAIL", response.data);
            resolve(response);
          })
          .catch((error) => {
            c;
            onsole.log(error), reject(error);
          });
      });
    },

    fetchDataListLogsByFilter({ commit }, { start, end }) {
      console.log("end date", dayjs(end).format("DD.MM.YYYY"));

      return new Promise((resolve, reject) => {
        axios
          .get("log/filter/", {
            params: {
              from: dayjs(start).format("DD.MM.YYYY"),
              to: dayjs(end).format("DD.MM.YYYY"),
            },
          })
          .then((response) => {
            // console.log("logs data by filter", response);
            commit("SET_LOGS", response.data);
            resolve(response);
          })
          .catch((error) => {
            console.log(error), reject(error);
          });
      });
    },
    fetchDataTrip({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios
          .get("log/trip/history/" + id + "/")
          .then((response) => {
            commit("SET_TRIPS", response.data);
            resolve(response);
          })
          .catch((error) => {
            console.log(error), reject(error);
          });
      });
    },
    fetchTrackings({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get("log/tracking/", { params })
          .then((response) => {
            // console.log(response);
            commit("SET_TRACKINGS", response.data);
            resolve(response);
          })
          .catch((error) => {
            console.log(error), reject(error);
          });
      });
    },
    fetchTracking({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get("log/tracking/" + params.driver_id + "/", {
            params: params,
          })
          .then((response) => {
            commit("SET_TRACKING", response.data);
            resolve(response);
          })
          .catch((error) => {
            console.log(error), reject(error);
          });
      });
    },
    ReportEmail({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .post(`log/report_get/${item.id}`, item.form, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
